import React, { Fragment } from 'react';

const FindLockCode = () => (
  <Fragment>
    <p>
      All the relevant information regarding the vehicle assigned to you is
      available on your{' '}
      <a
        className="faq__panel--link"
        href="http://www.autzu.com/dashboard">
        Dashboard
      </a>{' '}
      10 minutes prior to your booking start time. This will include: car
      model, license plate, lock box code and parking spot. You will also
      receive this information in a text message 10 minutes prior to your
      booking start time.
    </p>
  </Fragment>
);

export default FindLockCode;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/FindLockCode.js